import React, { useState ,useEffect} from "react";
import { useNavigate ,useParams } from "react-router-dom";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';
import { getSessionData } from "../utils/auth";



const Replies = () => {
    usePageTitle('Replies - Wefayo');
   
    const [replyList, setReplyList] = useState([]);
    const [reply, setReply] = useState("");
    const [title, setTitle] = useState("");
    const navigate = useNavigate();
    const { id } = useParams();


    const addReply = () => {
        fetch("http://localhost:4000/api/create/reply", {
            method: "POST",
            body: JSON.stringify({
                id,
                userId: getSessionData()?._id,
                reply,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                alert(data.message);
                navigate("/dashboard");
            })
            .catch((err) => console.error(err));
    };
  
    //👇🏻 This function when triggered when we add a new reply
    const handleSubmitReply = (e) => {
        e.preventDefault();
        // console.log({ reply });
        addReply();
        setReply("");
    };


    useEffect(() => {
        const fetchReplies = () => {
            fetch("http://localhost:4000/api/thread/replies", {
                method: "POST",
                body: JSON.stringify({
                    id,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setReplyList(data.replies);
                    setTitle(data.title);
                })
                .catch((err) => console.error(err));
        };
        fetchReplies();
    }, [id]);

    return (
        <CommunityLayout currentPage={"replies"} onCommunitiesLoaded={()=>{}} >
            <h1 className='repliesTitle'>{title}</h1>

            <form className='modal__content' onSubmit={handleSubmitReply}>
                <label htmlFor='reply'>Reply to the thread <span className="text-red-900 mx-1">*</span></label>
                <textarea
                    rows={5}
                    value={reply}
                    onChange={(e) => setReply(e.target.value)}
                    type='text'
                    name='reply'
                    className='modalInput'
                />

                <button role="button"  className='modalBtn'>SEND</button>
            </form>

            <div className='thread__container'>
                {replyList.map((reply) => (
                    <div className='thread__item'>
                        <p>{reply.text}</p>
                        <div className='react__container'>
                            <p style={{ opacity: "0.5" }}>by {reply.name}</p>
                        </div>
                    </div>
                ))}
            </div>
        </CommunityLayout>
    );
};

export default Replies;